var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 63,
    viewBox: "0 0 62 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.75 10.4648C30.9225 9.88734 25.06 9.58984 19.215 9.58984C15.75 9.58984 12.285 9.76484 8.82 10.1148L5.25 10.4648",
    stroke: "#FF0000",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.875 8.6975L15.26 6.405C15.54 4.7425 15.75 3.5 18.7075 3.5H23.2925C26.25 3.5 26.4775 4.8125 26.74 6.4225L27.125 8.6975",
    stroke: "#FF0000",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9877 15.9951L31.8502 33.6176C31.6577 36.3651 31.5002 38.5001 26.6177 38.5001H15.3827C10.5002 38.5001 10.3427 36.3651 10.1502 33.6176L9.0127 15.9951",
    stroke: "#FF0000",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0781 28.875H23.9056",
    stroke: "#FF0000",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.625 21.875H25.375",
    stroke: "#FF0000",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.dade29335aea75d830ff3414e58d8c8e.svg";
export { ForwardRef as ReactComponent };